var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showConfirmationModal)?_c('Modal',{attrs:{"config":_vm.modalConfig.confirmTaxSavings},on:{"btn1Action":function($event){return _vm.routeToAccountDetails(_vm.config)},"btn2Action":function($event){return _vm.routeToDashboard()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }